/**
 * This will compute the derived value for the estimated maximum annual ink cost
 */
import { createSelector } from 'reselect'
import data from '../data'

const getPlanId = (state, props) => state.selectedPlan.id;
const getPlanPages = (state, props) => state.selectedPlan.pages;
const getGenericInk = (state, props) => state.genericInk;
const getBlackOnlyInk = (state, props) => state.blackAndWhiteOnly;
const getHighYield = (state, props) => state.highYieldInk;
const getSelectedPrinter = (state, props) => data.printers.reduce((acc, printer) => {
    if (printer.id === state.selectedPrinter) {
        acc = printer;
    }

    return acc;
}, null);
const getInks = (state, props) => data.inks;

const getMaximumAnnualCost = createSelector(
    [getPlanId, getPlanPages, getSelectedPrinter, getInks, getHighYield, getGenericInk],
    (planId, planPages, printer, inks, highYield, genericInk) => {
        const hydratedInks = printer.inks.map((inkId) => inks.filter((ink) => ink.id === inkId)[0]);
        const printerInks = hydratedInks.filter((ink) => {
            return (ink.high_yield === highYield)
        }).filter((ink) => {
            return (!ink.generic)
        });


        //-- Use the current plan selected get the total of pages per year to print
        const pagesPerYear = planPages * 12;

        const totalInks = printerInks.length;
        //-- Okay how many ink cartridges will it take to provide the count?
        const totalPage = printerInks.reduce(((acc, ink) => acc + ink.pages), 0);
        const highestCost = printerInks.reduce(((acc, ink) => acc < ink.cost ? ink.cost : acc), 0);
        const avgPagesPerCartridge = Math.ceil(totalPage / totalInks);
        const avgCostPerCartridge = highestCost / printerInks.length;


        //-- Take the total pages per year against the pages per cartridge
        const minimumCost = Math.ceil((pagesPerYear / avgPagesPerCartridge)) * highestCost;


        if (planId === 36) {
            return 80;
        } else if (planId === 1) {
            return 80;
        } else if (planId === 2) {
            return 120;
        } else if (planId === 3) {
            return 240;
        }  else {
            return 520;
        }

        // return Math.round(0.1 * minimumCost) / 0.1;

        /*
                //-- This is important Max. ink depends on printing of color / black
                // except the pricing between black and color is nearly the same?
                // However, printer packs sell XL black and standard color, so assume more black ink?
                const totalInks = 12;
                const blackToColorRatio = 0.75;
                const blackRatio = totalInks * blackToColorRatio;
                const colorRatio = totalInks * (1 - blackToColorRatio);
                let inkTotal = printerInks.reduce((acc, ink) => {
                    let cost;
                    if (ink.type === "black") {
                        cost = ink.cost * blackRatio;
                    } else  {
                        cost = ink.cost * colorRatio;
                    }

                    return acc + cost;
                }, 0.00);

                return inkTotal;
                */
    }
);

export default getMaximumAnnualCost;
